import { motion } from 'framer-motion';
import { NAV_ITEMS } from '../../Const';

/**
 * ナビゲーションのリンク一覧。デスクトップのバーとモバイルのドロワーで共用する。
 * animate=true のときのみ順に fade-in させる（ドロワー用）。
 */
const NavLinks = ({ animate = false, onNavigate }) => {
  const animateFrom = { opacity: 0, y: -12 };
  const animateTo = { opacity: 1, y: 0 };

  return (
    <ul>
      {NAV_ITEMS.map((item, index) =>
        animate ? (
          <motion.li
            key={item.href}
            initial={animateFrom}
            animate={animateTo}
            transition={{ delay: 0.05 * index }}
            onClick={onNavigate}
          >
            <a href={item.href}>{item.label}</a>
          </motion.li>
        ) : (
          <li key={item.href}>
            <a href={item.href}>{item.label}</a>
          </li>
        ),
      )}
    </ul>
  );
};

export default NavLinks;
